import prod from './prod';

const homeDomain = 'customer.pre-prod.xfinity.com';
const mobileDomain = 'www.stg.xfinity.com/mobile';
const paymentDomain = 'payments.preprod.xfinity.com';

// This config should match prod as closely as possible, with only URL changes to meet
// consistency needs for links back to FE.
const CONFIG = {
  ...prod,
  homeDomain,
  mobileDomain,
  billServicesUrl: `https://${homeDomain}/billing/services`,
  billingUrl: `https://${homeDomain}/#/billing`,
  billingMobileUrl: `https://${homeDomain}/billing/mobile`,
  billingMobileTransactionsUrl: `https://${homeDomain}/billing/mobile/transactions`,
  makePaymentUrl: `https://${paymentDomain}/new`,
  paymentSetup: {
    ...prod.paymentSetup,
    // Where to go if no continueUrl specified (from consent flow)
    defaultContinue: `https://${homeDomain}/`,
  },
  featureFlagEndpoint: 'https://sdx.qa.xfinity.com/cms/data/myAccount/web/preprod/featureFlagsPreProd.json',
  oauthUrl: 'https://oauth.xfinity.com',
  coreCpcEnvironment: 'production',
  coreCpcUrl: 'https://common-payment.xfinity.com/',
  xmCpcEnvironment: 'preproduction',
  xmCpcUrl: 'https://common-payment.preprod.xfinity.com/',
  xmMyAccountUrl: `https://${mobileDomain}/my-account`,
  devicesMobileUrl: `https://${mobileDomain}/my-account/devices`,
  cimaClientId: 'my-account-web-preprod',
  cottonClientId: 'dss-mw-pci-preprod',
  firebaseEnabled: false,
  firebaseConfig: {
    apiKey: 'AIzaSyASbdXi4FOQ6G5jlfsWOCsqqpruV3mk4E4',
    authDomain: 'dss-maw-pci-dev-974534.firebaseapp.com',
    projectId: 'dss-maw-pci-dev-974534',
    storageBucket: 'dss-maw-pci-dev-974534.firebasestorage.app',
    messagingSenderId: '583702985741',
    appId: '1:583702985741:web:b068038f4137d53c07a944',
    measurementId: 'G-PM8G0F7J7J',
  },
};

export default CONFIG;
